import { computed } from 'vue';
import { NEWSLETTER_TYPES } from '../constants/constants';
export const useNewsletterType = (newsletterType) => {
	const isSubscribe = computed(() => newsletterType === NEWSLETTER_TYPES.SUBSCRIBE);
	const isUnsubscribe = computed(() => newsletterType === NEWSLETTER_TYPES.UNSUBSCRIBE);
	const isModify = computed(() => newsletterType === NEWSLETTER_TYPES.MODIFY);
	return {
		isSubscribe,
		isUnsubscribe,
		isModify
	};
};
